import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import IconButton from 'v3/components/Button/Icon';
import theme from 'v3/theme';

export const QuestionTypeFieldContainer = styled(Col)`
  @media (max-width: 767px) {
    padding-right: 12px;
  }
`;

export const QuestionGeneralInfoContainer = styled(Col)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1.5rem;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 100px;
    padding-left: 1rem;
    border-left: 1px dashed #c6cfda;
  }

  & > div > span:first-child {
    display: flex;
    align-items: flex-start;
    min-height: 28px;
    margin-bottom: 6px;
  }

  & > div .MuiFormControlLabel-root {
    min-height: 32px;
    align-items: center;
  }

  @media (max-width: 991px) {
    gap: 1.25rem;

    & > div {
      min-width: 100px;
      padding-left: 0.75rem;
    }
  }

  @media (max-width: 767px) {
    & > div {
      padding-left: 0;
      border-left: 0;
    }
  }
`;

export const AddAnswerButtonContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 28px;

  @media (max-width: 767px) {
    padding-top: 12px;
    justify-content: flex-start;
  }
`;

export const AddAnswerButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  &:hover:not(:disabled) {
    text-decoration: underline;
  }
  & > svg {
    color: ${theme.colors.success};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SortableAnswerColContainer = styled(Col)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const SortableAnswerInputWrap = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const SortableAnswerActions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
`;

export const SortableAnswerHandle = styled.button`
  border: 1px solid transparent;
  cursor: grab !important;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    border: 1px solid ${theme.colors.medium_gray};
  }
`;

export const SortableAnswerRemoveButton = styled(IconButton)`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid transparent;
  &:focus {
    border: 1px solid ${theme.colors.light_red};
  }
`;
